const mediaItems = [
  {
    id: 1,
    title: '国漫崛起：从模仿到超越的黄金十年',
    desc: '回顾国漫发展历程，盘点那些令人惊艳的国产漫画佳作',
    tag: '漫评专栏',
    icon: 'ri-article-line',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20and%20manga%20industry%20illustration%2C%20modern%20Chinese%20comic%20art%20style%20with%20traditional%20elements%2C%20warm%20coral%20and%20golden%20tones%2C%20creative%20studio%20scene%2C%20clean%20cream%20background%2C%20artistic%20atmosphere%2C%20high%20detail%20editorial%20illustration&width=1000&height=600&seq=media-card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '七月新番导览：不可错过的六部力作',
    desc: '夏季新番全面解读，从热血战斗到治愈日常应有尽有',
    tag: '新番速递',
    icon: 'ri-tv-line',
    image: 'https://readdy.ai/api/search-image?query=Summer%20anime%20season%20preview%20illustration%2C%20colorful%20vibrant%20anime%20style%20with%20various%20character%20silhouettes%2C%20warm%20amber%20and%20coral%20tones%2C%20clean%20cream%20background%2C%20festive%20atmosphere%2C%20high%20detail%20editorial%20art&width=1000&height=600&seq=media-card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '对话漫画作者：创作背后的故事与坚持',
    desc: '深度访谈系列，走进漫画创作者的内心世界与创作历程',
    tag: '作者专访',
    icon: 'ri-mic-line',
    image: 'https://readdy.ai/api/search-image?query=Manga%20artist%20studio%20workspace%20illustration%2C%20creative%20drawing%20desk%20with%20sketches%20and%20tools%2C%20warm%20cozy%20lighting%2C%20artistic%20atmosphere%2C%20cream%20and%20coral%20tones%2C%20clean%20background%2C%20editorial%20illustration%20style%2C%20high%20detail&width=1000&height=600&seq=media-card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '漫画改编影视作品大盘点：哪些值得看',
    desc: '从纸面到大银幕，盘点那些成功的漫画IP影视化改编案例',
    tag: '影视联动',
    icon: 'ri-film-line',
    image: 'https://readdy.ai/api/search-image?query=Film%20and%20manga%20crossover%20illustration%2C%20cinematic%20composition%20with%20manga%20panels%20transforming%20into%20movie%20scenes%2C%20warm%20golden%20and%20coral%20tones%2C%20clean%20cream%20background%2C%20creative%20concept%20art%2C%20high%20detail%20editorial&width=1000&height=600&seq=media-card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '同人创作精选：漫迷笔下的精彩世界',
    desc: '精选九妖漫画网社区优质同人作品，感受漫迷无限创意',
    tag: '同人精选',
    icon: 'ri-brush-line',
    image: 'https://readdy.ai/api/search-image?query=Fan%20art%20gallery%20illustration%2C%20colorful%20diverse%20character%20artworks%20in%20various%20styles%2C%20warm%20coral%20and%20amber%20palette%2C%20clean%20cream%20background%2C%20creative%20community%20atmosphere%2C%20high%20detail%20editorial%20illustration&width=1000&height=600&seq=media-card-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            漫讯速递
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            最新漫画资讯、深度漫评与精彩专题内容，一站式掌握动漫圈动态
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group rounded-2xl overflow-hidden bg-background-50 cursor-pointer hover:bg-background-50 transition-colors"
            >
              {/* Thumbnail */}
              <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={`${item.title} - ${item.tag}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-3 left-3">
                  <span className="flex items-center gap-1 px-2.5 py-1 bg-background-50/90 text-primary-600 text-xs font-medium rounded-full whitespace-nowrap">
                    <i className={item.icon}></i>
                    {item.tag}
                  </span>
                </div>
              </div>
              {/* Content */}
              <div className="p-5">
                <h3 className="font-heading font-bold text-sm md:text-base text-foreground-900 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs text-primary-600 font-medium">
                  <span className="whitespace-nowrap">阅读全文</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}